import React from 'react'

function Footer() {
  return (
    <footer id="footer" className="py-1 w-full static bottom-0 bg-yellow-600 text-center text-white text-lg">
        &copy; Copyright and Licensed to <a href="/#" className="font-bold transition-all duration-300 hover:text-gray-800">Yash Kadulkar</a>
    </footer>
  )
}

export default Footer